import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of as ObsOf, ReplaySubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { Admin } from '@app-models/site';


import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';

import * as uuid from 'uuid';

// import { environment } from '../../environments/environment';
import { environment } from '../../environments/environment.prod';

import { AppURL } from '../../app/app.url';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements CanActivate {

  private authState: firebase.User;
  private tokenId: string;
  private storageUrl: string;
  signoutEvent = new Subject();

  private secondaryFirebase: firebase.app.App;

  constructor(
    public afAuth: AngularFireAuth,
    private router: Router) {
      this.secondaryFirebase = firebase.initializeApp(environment.firebase, 'Secondary');
    // firebase.initializeApp(environment.firebase);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.afAuth.authState.pipe(map((auth: firebase.User) => {
      if (auth) {
        this.authState = auth;
        auth.getIdTokenResult().then((idTokenResult) => {
          // Confirm the user is an Admin.
          this.setTokenID(idTokenResult.token);
          return true;
        });
        return true;
      } else {
        this.router.navigate([AppURL.Login]);
        return false;
      }
    }
    ));
  }

  getAuthenState(): firebase.User {
    return this.authState;
  }

  setTokenID(inputTokenKey: string): void {
    this.tokenId = inputTokenKey;
  }

  getTokenID() {
    return this.tokenId;
  }

  authen(email: string, password: string, remember: boolean): Promise<any> {
    let persist = firebase.auth.Auth.Persistence.NONE;
    if (remember) {
      persist = firebase.auth.Auth.Persistence.LOCAL;
    }
    const promise = new Promise<any>((resolve, reject) => {
      firebase.auth().setPersistence(persist)
        .then(() => {
          firebase.auth().signInWithEmailAndPassword(email, password)
            .then((user: firebase.auth.UserCredential) => {
              // console.log(user);
              user.user.getIdTokenResult()
                .then((idTokenResult: firebase.auth.IdTokenResult) => {
                  // console.log(idTokenResult);
                  this.setTokenID(idTokenResult.token);
                  // console.log(idTokenResult.claims['user_id']);
                  resolve(idTokenResult.claims.user_id);
                }).catch((error) => {
                  reject(error);
                });
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }

  createUser(email: string, password: string) {
    const promise = new Promise<string>((resolve, reject) => {
      this.secondaryFirebase.auth().createUserWithEmailAndPassword(email, password).then(
        (value: any) => {
          this.secondaryFirebase.auth().signOut();
          resolve(value.user.uid);
        }
      ).catch((error: any) => {
        reject(error);
      });
    });
    return promise;
  }

  changePassword(email: string, password: string, newPassword: string) {
    const promise = new Promise((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
        // user signed in
        if (user) {
          firebase.auth().currentUser.updatePassword(newPassword).then((result) => {
              // Update successful.
              console.log('update password');
              resolve('update password');
            }).catch( (error) => {
              // An error happened.
              console.log('error : ' + error);
              reject(error);
            });
         } else {
          console.log('error else: ');
        }
      }).catch( (error) => {
        reject(error);
      });
    });
    return promise;

    // firebase.auth().sendPasswordResetEmail('user@example.com')
  }

  resetPassword(emailAddress: string) {
    const promise = new Promise((resolve, reject) => {
      firebase.auth().sendPasswordResetEmail(emailAddress).then(() => {
        // Email sent.
        console.log('send link reset password');
        resolve('success');
      }).catch((error) => {
        // An error happened.
        console.log(error);
        reject(error);
      });
    });
    return promise;
  }

  signOutUser() {
    firebase.auth().signOut().then((user) => {
      // Update successful.
      console.log('sign out');
      this.setTokenID('');
      this.signoutEvent.next();
      this.router.navigate([AppURL.Login]);
    }).catch( (error) => {
      // An error happened.
      console.log('error : ' + error);
    });
  }

  // pathLogo : path upload file
  // localFile: check auto choose file default logo. [true: use default logo with base64, false: use file from path]
  // fileName : use when need edit image with use same old name
  uploadLogoToFireStorage(pathLogo: any, localFile: boolean, fileName: string): Promise<string> {
    // TODO
    let logoName = '';
    const defaultImage = environment.defaultLogo64;
    const promise = new Promise<string>((resolve, reject) => {
      this.storageUrl = '';
      if (fileName === '') {
        logoName = uuid.v4();
      } else {
        logoName = fileName;
      }
      const storageRef = firebase.storage().ref(environment.urlStorage + logoName);
      if (localFile) {
        storageRef.putString(defaultImage, 'data_url').then((uploadFile) => {
          // upload logo
          console.log('success ' + uploadFile.ref);
          storageRef.getDownloadURL().then((pathUrl) => {
            // upload logo
            console.log('success2 ' + pathUrl);
            this.storageUrl = pathUrl;
            resolve(pathUrl);
          }).catch( (error) => {
            // Handle Errors here.
            console.log('error.code1 : ' + error.code + ', error.msg : ' + error.message);
          });
        }).catch( (error) => {
          // Handle Errors here.
          console.log('error.code2 : ' + error.code + ', error.msg : ' + error.message);
        });
      } else {
        storageRef.put(pathLogo[0]).then((uploadFile) => {
          // upload logo
          console.log('success ' + uploadFile.ref);
          storageRef.getDownloadURL().then((pathUrl) => {
            // upload logo
            console.log('success2 ' + pathUrl);
            this.storageUrl = pathUrl;
            resolve(pathUrl);
          }).catch( (error) => {
            // Handle Errors here.
            console.log('error.code1 : ' + error.code + ', error.msg : ' + error.message);
          });
        }).catch( (error) => {
          // Handle Errors here.
          console.log('error.code2 : ' + error.code + ', error.msg : ' + error.message);
        });
      }
    });
    return promise;
  }
}
